export const localizationStringsEn = {
  scan_the_front_side: 'Scan the front side of the document',
  scan_data_page: 'Scan the data page of the document',
  scan_top_page: 'Scan the top page',
  scan_left_page: 'Scan the left page',
  scan_right_page: 'Scan the right page',
  flip_document: 'Flip the document',
  wrong_top: 'Move to the top page',
  wrong_left: 'Move to the left page',
  wrong_right: 'Move to the right page',
  flip_to_back_side: 'Flip to the back side',
  move_top: 'Move to the top',
  move_left: 'Move to the left',
  move_right: 'Move to the right',
  scan_the_back_side: 'Scan the back side of the document',
  scan_the_barcode: 'Scan the barcode',
  move_closer: 'Move the document closer',
  move_farther: 'Move the document farther away',
  camera_angle_too_steep: 'Keep the document parallel to the phone',
  face_photo_not_fully_visible: 'Keep the face photo fully visible',
  document_too_close_to_edge: 'Move the document away from the edge',
  blur_detected: 'Keep the document and phone still',
  glare_detected: 'Tilt or move the document to remove glare',
  occluded: 'Keep the document fully visible',
  too_dark: 'Move to a brighter location',
  too_bright: 'Move to a less bright location',
  scan_unsuccessful: 'Scan unsuccessful',
  scan_unsuccessful_details: 'Unable to read the document. Please try again.',
  error_occurred: 'Error occurred',
  sdk_initialization_error: 'Error initializing the SDK',
  sdk_initialization_error_details:
    'An error occurred while initializing the BlinkID SDK.',
  camera_error: 'Camera error',
  camera_permission_denied:
    'Camera access denied. Please allow camera access and try again.',
  scan_time_exceeded: 'Scan time exceeded',
  scan_taking_longer_hint:
    'The scanning process is taking longer than expected. Please make sure the document is well lit, in focus, and correctly positioned within the camera frame.',
  document_not_supported: 'Document not supported',
  try_different_document: 'Try another document',
  document_not_supported_hint:
    'The document you are trying to scan is not supported by this application. Try scanning a different document.',
  document_not_recognized: 'Document not recognized',
  document_not_recognized_details: 'Scan the front of a supported document.',
  document_filtered: 'Document not accepted',
  label_from: 'from',
  onboarding_modal_title: 'Keep all details visible',
  onboarding_modal_details:
    'Make sure the document is well-lit. All fields must be visible on the screen.',
  onboarding_modal_btn: 'Start scan',
  help_modal_title_1: 'Keep all fields visible',
  help_modal_details_1:
    'Do not cover any part of the document with your finger, including the bottom lines. Pay attention to hologram reflections.',
  help_modal_title_2: 'Avoid direct light',
  help_modal_details_2:
    'Direct light can create glare that makes the document unreadable. If the data is unreadable, the camera cannot read it either.',
  help_modal_title_3: 'Stay still during the scan',
  help_modal_details_3:
    'Try to keep the phone and document still during the scan.',
  help_modal_back_btn: 'Back',
  help_modal_next_btn: 'Next',
  help_modal_done_btn: 'Done',
  help_aria_label: 'Help',
  help_tooltip: 'Need help?',
  alert_retry_btn: 'Retry',
  alert_cancel_btn: 'Cancel',
  screen_photo_error:
    'Please do not photograph a screen. Use the original document.',
  glare_photo_error:
    'Glare detected. Please avoid direct light or reflections.',
  copy_or_screenshot_photo_error:
    'The document appears to be a copy or screenshot. Please use the original document.',
  invalid_document_photo_error:
    'The document is incomplete, invalid, or inconsistent. Please check it again.',
  front_side_blur_or_glare_error:
    'The front side is blurry, has glare, or was not detected correctly.',
  both_sides_required_error:
    'Both sides of this document type must be uploaded. Please upload the second side.',
  invalid_file_type: 'Invalid file type. Please upload a JPG, JPEG, or PNG.',
  file_too_large_error: 'File is too large. Maximum 5 MB allowed.',
  scan_successful: 'Scan successful.',
} as const;
